var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.076 27.344l.006.99c0 1.027-3.548 2.841-6.282 3.85l-.908.335-.002.861v21.203c0 7.325 3.634 14.173 10.503 19.804a43.58 43.58 0 0010.439 6.334l.613.242.614-.242a43.555 43.555 0 0010.437-6.334C70.368 68.756 74 61.908 74 54.583v-22.06l-.909-.336c-2.736-1.01-5.867-2.871-5.867-3.9v-.943l-14.78-4.15-14.368 4.15z",
    fill: "url(#crypto-load_svg__paint0_linear_2461_16279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.444 80.966V23.193l14.78 4.152v.943c0 1.02 3.09 2.874 5.867 3.9l.908.335v22.063c0 7.325-3.632 14.173-10.503 19.804a43.643 43.643 0 01-10.437 6.333l-.615.243z",
    fill: "#000",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.208 60.826H46.681c-.795 0-1.365-.191-1.748-.586-.388-.398-.578-.997-.578-1.83v-8.693c0-1.319.757-2.22 2.024-2.413v-2.988a8.056 8.056 0 01.502-2.915 5.744 5.744 0 011.342-2.06 5.55 5.55 0 011.936-1.22 6.472 6.472 0 012.285-.404 5.964 5.964 0 014.22 1.633 5.77 5.77 0 011.34 2.065 8.08 8.08 0 01.501 2.917v2.966c.572.027 1.11.277 1.5.698.377.491.564 1.102.527 1.72v8.693c0 .834-.189 1.433-.578 1.831-.382.395-.953.586-1.747.586zm-7.4-4.947a.518.518 0 00-.52.52v.052a.518.518 0 00.52.52h.928v.398a.518.518 0 00.52.52h.225a.52.52 0 00.52-.52v-3.033c.404-.137.76-.388 1.023-.724.286-.36.436-.81.425-1.27a2.072 2.072 0 00-2.08-2.079 2.069 2.069 0 00-2.08 2.08c-.012.46.138.91.425 1.27.263.335.618.586 1.022.723v1.543h-.927zm1.653-16.21c-2.513 0-4.075 1.696-4.075 4.426v3.21h8.112l-.005-3.227c0-2.72-1.545-4.409-4.032-4.409zm-.092 13.264a.578.578 0 11.025-1.156.578.578 0 01-.025 1.155z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4a2 2 0 100-4v4zm0 96C25.49 100 4 78.51 4 52H0c0 28.719 23.281 52 52 52v-4zM4 52C4 25.49 25.49 4 52 4V0C23.281 0 0 23.281 0 52h4z",
    fill: "url(#crypto-load_svg__paint1_linear_2461_16279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crypto-load_svg__paint0_linear_2461_16279",
    x1: 52.445,
    y1: 23.193,
    x2: 52.445,
    y2: 90.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9C15"
  })))));
}
export default SvgCryptoLoad;